import { lazy, Suspense, type ReactNode } from "react";
import type { RouteObject } from "react-router-dom";
import { Navigate } from "react-router-dom";
import { HelpFlagGate } from "./helpFlag";

// App "Ayuda y Tutoriales" (#1015). Nodo del catálogo: app:settings.
// Se carga bajo demanda: el contenido completo de la wiki no debe viajar en el
// bundle principal de todos los usuarios.
const HELP_BASE = "/ayuda";
const HelpLayout = lazy(() => import("./HelpLayout"));
const WikiHome = lazy(() => import("./sections/WikiHome"));
const WikiCategory = lazy(() => import("./sections/WikiCategory"));
const WikiPageView = lazy(() => import("./sections/WikiPageView"));
const TutorialsSection = lazy(() => import("./sections/TutorialsSection"));

const load = (node: ReactNode) => <Suspense fallback={null}>{node}</Suspense>;

export const helpRoute: RouteObject = {
  path: HELP_BASE,
  // Apagada en Feature Flags, la ruta se cierra (CC-CONSOLE #1431).
  element: <HelpFlagGate>{load(<HelpLayout />)}</HelpFlagGate>,
  children: [
    { index: true, element: load(<WikiHome />) },
    { path: "wiki", element: <Navigate to={HELP_BASE} replace /> },
    { path: "wiki/:category", element: load(<WikiCategory />) },
    { path: "wiki/:category/:slug", element: load(<WikiPageView />) },
    { path: "tutoriales", element: load(<TutorialsSection />) },
  ],
};

// El mosaico histórico "Tutoriales" apuntaba a /settings: se conserva el enlace.
export const legacyHelpRoute: RouteObject = {
  path: "/settings",
  element: <Navigate to={HELP_BASE} replace />,
};
